export default ".back svg {\n  width: 20px;\n}\n.back svg path {\n  fill: #1c69d3;\n}"